export function importAll(r: WebpackRequireContext): { [key: string]: string } {
    let images: { [key: string]: string } = {};
    r.keys().forEach((item: string) => {
      images[item.replace('./', '')] = r(item) as string;
    });
    return images;
  }
  